import { ExitToApp, Menu } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { Link } from "react-router-dom";

interface Props {
  userName: string;
  isSideBarOpen: boolean;
  onMenuIconClick: () => void;
}

const Header: React.FC<Props> = (props) => {

  return (
    <div className="app-header">
      <IconButton
        className={`open-menu-button ${!props.isSideBarOpen ? "active" : ""}`}
        onClick={() => props.onMenuIconClick()}>
        <Menu />
      </IconButton>
      <span className={`title ${props.isSideBarOpen ? "active" : ""}`}><strong>Hoşgeldiniz, {props.userName}</strong></span>
      <div className="links">
        <Link className="logout-btn" to="/logout" title="Çıkış">
          <ExitToApp />
        </Link>
      </div>
    </div>
  );
};

export default Header;
